export const LOCALSTORAGE_USER_KEY = "_fc_userId";
